module.exports = __webpack_public_path__ + "assets/img/Ic_exclamation-marks-green.905b1f93.svg";